import React from "react";

// Text-forward section: explains the referral model in plain language.
// Deliberately light on markup so the page carries a healthy share of real copy.
export const About = () => {
  return (
    <section data-testid="about-section" className="bg-white py-16 md:py-24">
      <div className="max-w-3xl mx-auto px-6 md:px-8">
        <p className="text-xs uppercase tracking-[0.24em] font-bold text-[#54BCE6] mb-4">Why homeowners start here</p>
        <h2 className="font-display text-[#133955] font-extrabold tracking-tighter text-3xl md:text-4xl leading-tight mb-8">
          A Simpler Way to Find the Right Contractor in the Lowcountry.
        </h2>

        <div className="space-y-5 text-base md:text-lg leading-relaxed text-[#173042]/80">
          <p>
            Home Pro Connect is a local connection service for homeowners across the South Carolina
            Lowcountry and Grand Strand — from Summerville, Charleston, and Mount Pleasant to
            Myrtle Beach, Conway, and Georgetown. Instead of calling around and repeating your
            project details to a dozen companies, you tell us once. We review your request and
            work to connect you with a contractor from our network whose services fit what you
            actually need.
          </p>
          <p>
            Not every project needs the same kind of pro. Additions, full remodels, demolition,
            and new home builds are coordinated by a general contractor who manages the trades,
            schedules, and moving parts. Everyday home services — HVAC, plumbing, roofing,
            flooring, painting, fencing, lawn care, tree removal, and more — go to specialists who
            focus on that exact trade. Our job is to understand which kind of help your project
            calls for and make the right introduction.
          </p>
          <p>
            We believe in being straightforward about what we do. Home Pro Connect is a referral
            service — we are not a contractor, and we do not perform, supervise, or guarantee any
            work. The contractor you connect with is an independent business, and the decisions —
            pricing, scheduling, contracts, and the work itself — stay between you and them. We
            always encourage homeowners to ask questions, request references, and confirm the
            details that matter to them before any work begins.
          </p>
          <p>
            Whether you are planning a full home renovation or just need a leaking pipe fixed
            before the weekend, the process starts the same way: one simple request. Share a few
            details about your project, and we will take it from there.
          </p>
        </div>

        <div className="mt-10">
          <a
            href="#request"
            data-testid="about-cta"
            className="inline-flex items-center rounded-full bg-[#133955] text-white px-8 py-4 font-bold hover:bg-[#54BCE6] hover:text-[#133955] transition-colors duration-300 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#133955] focus-visible:ring-offset-2"
          >
            Request a Connection
          </a>
        </div>
      </div>
    </section>
  );
};
